import React from "react";
import { Link } from "react-router-dom";
import { BASE_URL, IMG } from '../../constant';

const getDiscountPercentage = (regularPrice, salePrice) => {
    if (regularPrice && salePrice && regularPrice > salePrice) {
        return ((regularPrice - salePrice) / regularPrice) * 100;
    }
    return 0;
};

const getLowestSalePrice = (pro_var) => {
    if (pro_var && pro_var.length > 0) {
        const prices = pro_var.map((variant) => parseFloat(variant.sale_price || 0));
        return Math.min(...prices);
    }
    return null;
};

const RenderItem = ({ hit }) => {
    const discount = getDiscountPercentage(hit.regular_price, hit.sale_price);
    const lowestPrice = getLowestSalePrice(hit.ProVar);

    return (
        <div className={`product-card ${hit.stock_status === 'Out of stock' ? 'out-of-stock' : ''}`}>
            <Link to={`/product/${hit.slug}`}>
                <img src={hit.thumbnail ? BASE_URL + hit.thumbnail : "https://via.placeholder.com/150"} alt={hit.title} className="product-image" />
                <h4 className="product-title">{hit.title}</h4>
                {lowestPrice !== null ? (
                    <div className="product-price">
                        <span className="price_regular">Starting @ <span className="price_sale">₹{lowestPrice}</span></span>
                    </div>
                ) : hit.sale_price ? (
                    <>
                        <div className="product-price">
                            <div className="priceRow">
                                <span className="price_regular">MRP </span> <span className="price_regular strike">₹{hit.regular_price}</span>
                            </div>
                            <div className="priceRow">
                                <span className="price_sale">₹{hit.sale_price}</span> <span className="price_discount">({discount.toFixed(0)}% OFF)</span>
                            </div>
                        </div>
                        <div className="discount-badge-wrapper">
                            <img src={IMG.tag} className="discount-badge" alt="discount-badge" />
                            <div className="discount-badge-text">{discount.toFixed(0)}% OFF</div>
                        </div>
                    </>
                ) : (
                    <div className="product-price">
                        <span className="price_regular">₹{hit.regular_price}</span>
                    </div>
                )}
            </Link>
        </div>
    );
};

export default RenderItem;
